import React from "react";
import "./skills.css";
import skills from '../../assets/data.json';

const Skills = () => {
    return (
        <section id="skills">
            <span className="skillTitle">My Skills</span>
            
            <div className="skillBars">
                {skills.skills.map((skillGroup) => (
                    <div className="skillBar" key={skillGroup.id}>
                        <img src={skillGroup.image} alt="" className="skillBarImg" />
                        <div className="skillBarText">
                            <h2>{skillGroup.title}</h2>
                            {skillGroup.skills.map((skill, index) => (
                                <p key={index}>
                                    <b>{skill.title}:</b> {skill.description}
                                </p>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Skills